import React, { useState } from 'react'
import useScript from 'react-script-hook'
import { ButtonPrimary, ButtonClean } from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'

import { FormRow } from '../common/form/Form'
import HorizontalChoiceSelector from '../common/horizontal-choice-selector/HorizontalChoiceSelector'
import IconLock from '../common/icon/IconLock'
import IconLockOpen from '../common/icon/IconLockOpen'
import { Modal } from '../common/modal/Modal'
import { notification } from '../common/notifications/Notifications'

let status

export const MicrosoftPicker = (props) => {
  const [modalShown, setModalShown] = useState(false)
  const [scopeIsAnonymous, setScopeIsAnonymous] = useState(false)

  useScript({
    src: 'https://js.live.net/v7.2/OneDrive.js',
    onload: () => {
      status = 'ready'
    }
  })

  const getPickerRedirectUri = () => {
    if (process.env.LOOOP_ENVIRONMENT === 'dev') {
      // Or use ngrok but using it requires adding the endpoint into the Looop-file-picker app on azure
      return 'http://localhost:3000'
    }

    return `${location.protocol}//${location.host}`
  }

  const onChoose = async () => {
    var odOptions = {
      clientId: '0af2eecb-47c2-4f2b-a78d-1bba1753d358',
      action: 'share',
      multiSelect: false,
      advanced: {
        redirectUri: `${getPickerRedirectUri()}/oneDrivePicker`,
        createLinkParameters: {
          type: 'view',
          scope: scopeIsAnonymous ? 'anonymous' : 'organization'
        }
      },
      success: (files) => {
        if (files.message === 403) {
          notification.error(
            t`Access denied. It is likely that your organisation does not allow sharing of SharePoint files publicly. Please contact your administrator to lift the restrictions or use a file from your OneDrive.`
          )
        }
        props.onChange(files, scopeIsAnonymous)
      },
      error: (error) => {
        notification.error(error.message)
      }
    }
    // @ts-expect-error
    OneDrive.open(odOptions)
  }

  const options = [
    {
      value: true,
      header: (
        <>
          <IconLockOpen />
          <br />
          <Trans>Public</Trans>
        </>
      ),
      description: (
        <div className="description">
          <span>
            <Trans>Anyone with the link to the file can view</Trans>
          </span>
        </div>
      )
    },
    {
      value: false,
      header: (
        <>
          <IconLock />
          <br />
          <Trans>Private</Trans>
        </>
      ),
      description: (
        <div className="description">
          <span>
            <Trans>
              Only users that have granted access to the file can view
            </Trans>
          </span>
        </div>
      )
    }
  ]

  return (
    <div>
      {status === 'ready' && (
        <div onClick={() => setModalShown(true)}>
          {props.children ? (
            props.children
          ) : (
            <button>
              <Trans>Open Microsoft file picker</Trans>
            </button>
          )}
        </div>
      )}
      <Modal
        className="CreateWorkspaceModal"
        show={modalShown}
        onHide={() => {
          setModalShown(false)
        }}
        controls={[
          <ButtonClean
            key={'cancel'}
            onClick={() => {
              setModalShown(false)
            }}
          >
            <Trans>Cancel</Trans>
          </ButtonClean>,
          <ButtonPrimary
            key={'ok'}
            onClick={() => {
              setModalShown(false)
              onChoose()
            }}
          >
            <Trans>OK</Trans>
          </ButtonPrimary>
        ]}
      >
        <FormRow>
          <HorizontalChoiceSelector
            name="type"
            onChange={(val) => {
              setScopeIsAnonymous(val)
            }}
            options={options}
            value={scopeIsAnonymous}
          />
        </FormRow>
        <FormRow>
          <div className="form-hint">
            <Trans>
              Note:{' '}
              <em>
                If you choose Public and choose file from SharePoint you might
                see access denied in case your organisation doesn't allow to
                share files publicly from Sharepoint. You can contact your
                administrator and ask to lift this restriction or choose file
                from OneDrive instead.
              </em>
            </Trans>
          </div>
        </FormRow>
      </Modal>
    </div>
  )
}
